import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';

import { Store, select } from '@ngrx/store';
import { AppConfigurationDto } from '@cradua/data';
import { Observable } from 'rxjs/internal/Observable';
import { routeAnimations, ROUTE_ANIMATIONS_ELEMENTS } from 'libs/core/src/lib/animations';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';

@Component({
  selector: 'cradua-app-configuration-container',
  templateUrl: './app-configuration-container.component.html',
  styleUrls: ['./app-configuration-container.component.scss']
})
export class AppConfigurationContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  appconfigurations$: Observable<AppConfigurationDto[]>;
  loading: boolean;
  isLoading$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.isLoading$ = this.gatwayFacade.isLoadingGateway("AppConfiguration");
    this.appconfigurations$ = this.gatwayFacade.loadGateway("AppConfiguration");
    this.appconfigurations$.subscribe(data => {
      console.log("data: cont.",data);

    })
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteAppConfiguration(deletedValue: any) {
    this.gatwayFacade.remove("AppConfiguration", deletedValue);
    // this.store.dispatch(AppConfigurationStoreActions.removeAppConfiguration({ids: deletedValue}));
    this.notificationService.success('Deleted Successfully');
  }


// this method control both the create and update

  onSubmitAppConfiguration(formValue: any) {
    console.log("form value: ", formValue);
    formValue.AppConfigurations = formValue.AppConfigurations.reverse();
    event.preventDefault();
    const pullData = formValue.AppConfigurations;
    //const newPullData = formValue.AppConfigurationes;

// declare two empty array to hold update and create data
  let allUpdates = [] ;
  let addAllAppConfiguration = [];


// loop through the form data to check for update and create

  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllAppConfiguration.push(pullData[i]);
    }
  }

// check if the addAllAppConfiguration array is not empty, then dispatch the data to the store
   if(addAllAppConfiguration.length !== 0) {
    this.gatwayFacade.add('AppConfiguration', addAllAppConfiguration);
    // this.store.dispatch(AppConfigurationStoreActions.addAppConfiguration({newAppConfiguration: addAllAppConfiguration}));

   }

// dispatch update data to the store
this.gatwayFacade.update('AppConfiguration', allUpdates, ['id']);
    // this.store.dispatch(AppConfigurationStoreActions.updateAppConfiguration({updateAppConfiguration: allUpdates}));
    this.notificationService.success('Saved Successfully');

  }

}

